import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReportGameIssue from 'containers/ReportGameIssue';
import A11yFontIcon from 'components/A11yFontIcon';
import TextButton from 'components/TextButton';
import { isAuthenticated } from 'utils/auth';
import { isEmployeeEnv } from 'utils/constants';
import { getUserData } from 'utils/graphQLFunctions';
import { isEmbedded, isMobileDevice_DEPRECATED } from 'utils/mode';
import { errorShape, userShape } from 'utils/shapes';
import {
  clearCallbacks,
  hideChat,
  setCallbacks,
  setUserData,
  showChat,
  toggleChat
} from 'utils/zendesk';
import IconSupportChat from 'resources/icon-support-chat.svg';
import IconSupportChatActive from 'resources/icon-support-chat-active.svg';
import './SupportButton.css';

class SupportButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      supportOpen: false,
      reportGameIssueFormOpen: false,
      isChatOpen: false
    };

    this.toggleSupport = this.toggleSupport.bind(this);
    this.closeSupport = this.closeSupport.bind(this);
    this.openSupport = this.openSupport.bind(this);
    this.openReportGameIssueForm = this.openReportGameIssueForm.bind(this);
  }

  componentDidMount() {
    const user = this.props.data && this.props.data.user;
    if (user) {
      setUserData(user);
    }
    if (!isMobileDevice_DEPRECATED()) {
      setCallbacks({
        onHide: this.closeSupport,
        onShow: this.openSupport,
        onChatStart: this.chatWidgetOpen,
        onChatEnd: this.chatWidgetClose
      });
    }
    if (this.props.fromSupportPage) {
      this.setState({
        supportOpen: true,
        reportGameIssueFormOpen: true
      });
    }
  }

  componentWillUnmount() {
    if (!isMobileDevice_DEPRECATED()) {
      clearCallbacks({
        onHide: this.closeSupport,
        onShow: this.openSupport,
        onChatStart: this.chatWidgetOpen,
        onChatEnd: this.chatWidgetClose
      });
    }
  }

  chatWidgetClose = () => {
    this.setState({
      isChatOpen: false
    });
  };

  chatWidgetOpen = () => {
    this.setState({
      isChatOpen: true
    });
  };

  componentDidUpdate(prevProps) {
    const prevUser = prevProps.data && prevProps.data.user;
    const nextUser = this.props.data && this.props.data.user;
    if (prevUser !== nextUser) {
      setUserData(nextUser);
    }
  }

  closeSupport() {
    this.setState(
      {
        supportOpen: false,
        reportGameIssueFormOpen: false,
        isChatOpen: false
      },
      () => {
        if (this.props.closeCallBack) {
          this.props.closeCallBack();
        }
      }
    );
  }

  openSupport() {
    this.setState({
      supportOpen: true,
      reportGameIssueFormOpen: false,
      isChatOpen: true
    });
  }

  openReportGameIssueForm() {
    if (this.state.supportOpen && !this.state.reportGameIssueFormOpen) {
      hideChat();
      this.setState({
        supportOpen: true,
        reportGameIssueFormOpen: true
      });
    }
  }

  toggleSupport() {
    if (!isMobileDevice_DEPRECATED()) {
      if (this.state.reportGameIssueFormOpen) {
        this.closeSupport();
      } else {
        toggleChat();
      }
    } else {
      showChat();
    }
  }

  render() {
    const { className, inline, children, withReportGameIssue } = this.props;
    const setClassName = `support-button${
      inline ? ' support-button-inline' : ''
    } ${className || ''}`;

    if (isEmbedded() || isEmployeeEnv()) {
      if (inline) {
        return <div className={setClassName}>Support Chat</div>;
      } else {
        return null;
      }
    }

    let content = null;
    if (children) {
      content = children;
    } else if (inline) {
      content = (
        <>
          <A11yFontIcon icon="comments" alt="" /> Support Chat
        </>
      );
    } else {
      content = (
        <div className="support-chat">
          <img
            alt="Open Support Chat"
            src={
              this.state.isChatOpen ? IconSupportChatActive : IconSupportChat
            }
          />
          <span> Support Chat</span>
        </div>
      );
    }

    return (
      <div className={setClassName}>
        {withReportGameIssue && isAuthenticated() && (
          <ReportGameIssue
            supportOpen={this.state.supportOpen}
            formOpen={this.state.reportGameIssueFormOpen}
            close={this.closeSupport}
            open={this.openReportGameIssueForm}
          />
        )}
        {!this.props.fromSupportPage && (
          <TextButton onClick={this.toggleSupport}>{content}</TextButton>
        )}
      </div>
    );
  }
}

SupportButton.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    error: errorShape,
    user: userShape
  }),
  className: PropTypes.string,
  inline: PropTypes.bool,
  withReportGameIssue: PropTypes.bool,
  children: PropTypes.any,
  fromSupportPage: PropTypes.bool,
  closeCallBack: PropTypes.func
};

const withUserData = getUserData({ skip: () => !isAuthenticated() });

export default withUserData(SupportButton);
